<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Fatura Dönemleri</label>
            <v-select-list v-model="period" multiple placeholder="Fatura Dönemi" :options="periods"/>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Filo</label>
            <v-select-list v-model="fleet" multiple placeholder="Filo" label="Name" :options="fleets"/>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Plaka</label>
            <v-select-list v-model="plate" multiple placeholder="Plaka" label="PlateValue" :options="plates"/>
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Plaka Tanımlı Mı?</label>
            <v-select-list v-model="c_IsPlateDefined" placeholder="Plaka Tanımlı Mı?" label="StatusLabel" :options="plateDefineStatuses"/>
        </div>
        <div class="col-auto mb-1 mb-md-0">
            <button class="btn btn-secondary" v-on:click="setFilter">Filtrele</button>
        </div>
        <div class="col-auto mb-1 mb-md-0">
            <button class="btn btn-dark" v-on:click="clearFilter">Temizle</button>
        </div>
    </div>
</template>

<script>
import FuelOperationApi from '@/api/fuel-operations'
import VehicleOperationsApi from '@/api/vehicle-operations'
export default {
    data() {
        return {
            periods:[],
            fleets:[],
            plates:[],
            plateDefineStatuses:[
                {StatusLabel:'Tümü', StatusValue:null},
                {StatusLabel:'Evet', StatusValue:true},
                {StatusLabel:'Hayır',StatusValue:false}
            ],
            filter:{
                IsPlateDefined:null,
                InvoicePeriods:[],
                Fleets:[],
                Plates:[]
            }
        }
    },
    mounted(){
        this.getPeriods()
        this.getFleets()
        this.getPlates()
    },
    methods:{
        getPeriods(){
            FuelOperationApi.TotalFuelLoadPeriod().then(res=>{
                this.periods = res.data.Data
            })
        },
        getFleets(){
            FuelOperationApi.TotalFleet.List().then(res=>{
                this.fleets = res.data.Data
            })
        },
        getPlates(){
            VehicleOperationsApi.Plate.ListAll().then(res => {
                this.plates = res.data.Data
            })
        },
        clearFilter(){
            this.filter.InvoicePeriods = []
            this.filter.Fleets = []
            this.filter.Plates = []
            this.filter.IsPlateDefined = null
            this.$emit("filter",this.filter)
        },
        setFilter(){
            this.$emit("filter",this.filter)
        },
    },
    computed:{
        c_IsPlateDefined:{
            get:function(){
                return this.plateDefineStatuses.find(s=>s.StatusValue==this.filter.IsPlateDefined)
            },
            set:function(value){
                debugger;
                this.filter.IsPlateDefined = value?.StatusValue 
            }
        },
        period:{
            get:function(){
                return this.periods.filter(s=>this.filter.InvoicePeriods.includes(s))
            },
            set:function(value){
                this.filter.InvoicePeriods = value || null
            }
        },
        fleet:{
            get:function(){
                return this.fleets.filter(s=>this.filter.Fleets.includes(s.FleetCode))
            },
            set:function(value){
                this.filter.Fleets = value?.map(c=> c.FleetCode) || null
            }
        },
        plate:{
            get:function(){
                return this.plates.filter(s=>this.filter.Plates.includes(s.Id))
            },
            set:function(value){
                this.filter.Plates = value?.map(c=> c.Id) || null
            }
        },
    }
}
</script>

<style>

</style>